import { Node, mergeAttributes } from "@tiptap/core";
import { ReactNodeViewRenderer } from "@tiptap/react";
import LSDBButtonView from "./LSDBButtonView";

export default Node.create({
  name: "lsdbButton",

  group: "block", // Must be block level if rendering full-width flex layout

  atom: true,

  addAttributes() {
    return {
      url: {
        default: "",
      },
      alignment: {
        default: "right",
      },
      prefill: {
        default: true,
      },
      is_image: {
        default: false,
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: "lsdb-button",
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ["lsdb-button", mergeAttributes(HTMLAttributes)];
  },

  addNodeView() {
    return ReactNodeViewRenderer(LSDBButtonView);
  },
});